var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.viewYn)?_c('v-app',{staticClass:"bg-main wid-100"},[_c('v-container',{attrs:{"fluid":""}},[_c('header-a',{staticClass:"gloHeaderA"}),_c('body-a',{staticClass:"gloBodyA"}),_c('footer-d',{staticClass:"gloFooterD"})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }